import { styled } from '@mui/material/styles';
import TableRow from '@mui/material/TableRow';
import { customerTableColors } from '../helpers/customerTableColors';

export const StyledBodyRow = styled(TableRow)(() => ({
    '&:hover': {
        cursor: 'pointer',
        backgroundColor: customerTableColors.backgroundHoverRow,
    },
    '&.Mui-selected, &.Mui-selected:hover': {
        backgroundColor: customerTableColors.backgroundSelectedRow,
    },
}));
